import { render } from "./BiboActivation.vue?vue&type=template&id=4ae2e327"
import script from "./BiboActivation.vue?vue&type=script&lang=ts"
export * from "./BiboActivation.vue?vue&type=script&lang=ts"
script.render = render

export default script